<template>
  <SportPageSkeleton v-if="!isFullActualLoaded" />
  <section v-else class="all-sports-page">
    <LockEvents />
    <SportTabs
      v-if="sportTabs.length"
      :items="sportTabs"
      :selected-tabs-ids="selectedTabsIds"
      class="sport-tabs"
      @select="handleSelectTabs"
    />
    <div class="events">
      <SportList class="events-list" :render-full-tree="fullSportsTree" />
    </div>
  </section>
</template>

<script setup lang="ts">
const events = useSportEvents()

const { fullSportsTree } = useInitSportTree(events)
const { sportTabs, selectedTabsIds, handleSelectTabs } = useSportTabs(events)

const { isFullActualLoaded } = useFullActualLoaded()

useSeoData('sport-all')
</script>

<style scoped>
.sport-tabs {
  z-index: 6;
  top: 60px;

  padding-top: var(--spacing-200);
  padding-bottom: var(--spacing-200);

  background-color: var(--background-base);
}

.all-sports-page {
  --sport-header-top: 174px;
  --tournament-panel-top: 222px;

  padding-bottom: var(--spacing-600);

  .sport-tabs {
    position: sticky;
  }
}
</style>
